import React from "react";
import trainsEscapeIcon from "../assets/icons/trainsescape-app-icon.svg";
import trainsEscapeMockup from "../assets/mockups/trainsescape-mockup.png";
import trainsEscapeMockup2 from "../assets/mockups/trainsescape-mockup-2.png";
import appleStoreBadge from "../assets/badges/apple-store-badge.svg";
import googlePlayBadge from "../assets/badges/google-play-badge.svg";
import NavBar from "./NavBar";
import { publishedApps } from "../data/appData";

const TrainsEscapePage = ({ language, onLanguageChange, t }) => {
  const trainsEscapeApp =
    publishedApps.find((app) => app.detailPath === "/apps/trainsescape") || {};
  const appStoreUrl = trainsEscapeApp.appStoreUrl || "#";
  const googlePlayUrl = trainsEscapeApp.googlePlayUrl || "#";
  const highlights = t("trains.highlights.items") || [];
  const steps = t("trains.workflow.steps") || [];
  const personas = t("trains.personas.items") || [];

  return (
    <div className="page foody-page trains-page" id="trains-top">
      <NavBar
        language={language}
        onLanguageChange={onLanguageChange}
        items={[
          { href: "/#apps", label: t("trains.meta.back") },
          {
            href: "/apps/trainsescape/static/support",
            label: t("trainsSupport.badge"),
            className: "nav-support-outline",
          },
        ]}
      />

      <main className="foody-main">
        <section className="foody-hero">
          <div className="foody-hero-copy">
            <div className="foody-hero-icon">
              <img src={trainsEscapeIcon} alt="Trains Escape game icon" />
            </div>
            <span className="foody-eyebrow">{t("trains.hero.eyebrow")}</span>

            <h1>{t("trains.hero.title")}</h1>
            <p>{t("trains.hero.subtitle")}</p>
            <div className="store-badges foody-store-badges">
              {trainsEscapeApp.appStoreUrl && (
                <a
                  className="store-badge"
                  href={appStoreUrl}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={appleStoreBadge} alt="App Store" />
                </a>
              )}
              {trainsEscapeApp.googlePlayUrl && (
                <a
                  className="store-badge"
                  href={googlePlayUrl}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={googlePlayBadge} alt="Google Play" />
                </a>
              )}
            </div>
          </div>
          <div className="foody-hero-visual">
            <div className="foody-mockup trains-mockups">
              <img src={trainsEscapeMockup} alt="Trains Escape game screen 1" />
              <img src={trainsEscapeMockup2} alt="Trains Escape game screen 2" />
            </div>
          </div>
        </section>

        <section className="foody-section">
          <div className="foody-section-head">
            <h2>{t("trains.highlights.title")}</h2>
            <p>{t("trains.highlights.subtitle")}</p>
          </div>
          <div className="foody-grid">
            {highlights.map((item) => (
              <article className="foody-card" key={item.title}>
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
              </article>
            ))}
          </div>
        </section>

        <section className="foody-section foody-section-alt">
          <div className="foody-section-head">
            <h2>{t("trains.workflow.title")}</h2>
            <p>{t("trains.workflow.subtitle")}</p>
          </div>
          <div className="foody-steps">
            {steps.map((step, index) => (
              <div className="foody-step" key={step.title}>
                <span className="foody-step-index">0{index + 1}</span>
                <div>
                  <h3>{step.title}</h3>
                  <p>{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="foody-section">
          <div className="foody-section-head">
            <h2>{t("trains.personas.title")}</h2>
            <p>{t("trains.personas.subtitle")}</p>
          </div>
          <div className="foody-tags">
            {personas.map((item) => (
              <span className="foody-tag" key={item}>
                {item}
              </span>
            ))}
          </div>
          <p className="foody-note">{t("trains.personas.note")}</p>
        </section>

        <section className="foody-cta">
          <div>
            <h2>{t("trains.cta.title")}</h2>
            <p>{t("trains.cta.desc")}</p>
          </div>
          <div className="store-badges foody-store-badges">
            {trainsEscapeApp.appStoreUrl && (
              <a
                className="store-badge"
                href={appStoreUrl}
                target="_blank"
                rel="noreferrer"
              >
                <img src={appleStoreBadge} alt="App Store" />
              </a>
            )}
            {trainsEscapeApp.googlePlayUrl && (
              <a
                className="store-badge"
                href={googlePlayUrl}
                target="_blank"
                rel="noreferrer"
              >
                <img src={googlePlayBadge} alt="Google Play" />
              </a>
            )}
          </div>
        </section>
      </main>
    </div>
  );
};

export default TrainsEscapePage;
